<template>
  <div
    class="audio-container read-only"
    :data-url="url"
    :data-attachmentId="attachmentId"
    :data-duration="duration"
    :data-text="text"
    :data-filename="filename"
    :data-description="description"
    @mousedown="mousedownHandler"
    :id="attachmentId"
  >
   <!-- 音频 s -->
    <audio
      :src="url"
      style="{ display: 'none' }"
      controlslist="nodownload nofullscreen noremoteplayback"
      disablePictureInPicture
      ref="audio"
      @play="onPlay"
      @pause="onPause"
      @ended="onStop"
      @waiting="onLoading"
      @canplay="onCanPlay"
      @timeupdate="onTimeUpdate"
      @loadedmetadata="onLoadedMeteData"
    >
    </audio>
    <!-- 音频 e -->
    <section class="audio-player-controls">
      <!-- 播放按钮 s -->
      <section class="btn" @click="handleClick">
        <span v-if="status === 'stop'">
          <svg-icon name="play_audio"></svg-icon>
        </span>
        <span v-if="status === 'play'">
          <svg-icon name="pause_audio"></svg-icon>
        </span>
        <span v-if="status === 'loading'">
          <svg-icon name="loading_audio"></svg-icon>
        </span>
      </section>
      <!-- 播放按钮 e -->
      <!-- 当前时长 s -->
      <section class="currentTime">{{ formatTime }}</section>
      <!-- 当前时长 end -->
      <!-- 进度条 s -->
      <section class="seek-bar-back" ref="seek" @touchstart="onDragStart" @mousedown="onDragStart">
        <section class="seek-bar-progress" :style="{transform: `scaleX(${currentTime / computedDuration})`}"></section>
        <section
          :class="`seek-bar-progress-btn ${isDraggingProgress ? 'is-drag' : ''}`"
          :style="{left: `${((currentTime / computedDuration) * 100).toFixed(0)}%`}"
        ></section>
      </section>
     <!-- 进度条 e -->
      <!-- 总时长 s -->
      <section class="duration">{{ formatDuration }}</section>
      <!-- 总时长 e -->
    </section>
    <!-- 语音转文字部分s -->
    <section v-show="!!text" class="audio-transfer-text" >
      <p class="transfer-text-label">以下内容为语音转文字，不保证准确，仅供参考</p>
      <div class="audio-text" :style="collapsesStyle">
        <p class="inner-text" ref="innerWrap">{{ text }}</p>
        <div class="collapse-btn" :style="collapsesBtnStyle">
          <div @click="handleToggle">
            <span>{{ collapsesOpen ? '收起' : '展开' }}</span>
            <svg-icon class="arrow" :class="collapsesOpen ? 'active' : ''" name="arrow"></svg-icon>
          </div>
        </div>
      </div>
    </section>
    <!-- 语音转文字部分end -->
  </div>
</template>
<script>
import toast from '@hb/hb-toast';
import jsBridge from '@hb/hb-jsbridge';
import { isPc } from '../../../utils/resetScrollPos';
import { getCurrentProgress } from '../../common/getAudioCurrentProgress';
let timeOnMouseMove = 0;
const textFontSize = 16;
const textLineHeight = 1.8;
const textLineCount = 2;
export default {
  props: {
    env: {
      type: String,
      default: 'web'
    }
  },
  data() {
    return {
      duration: 0, // 音频时长
      url: '', // 看渲染 url 和 url 一样呢 lyurtodo
      attachmentId: '', // 附件id
      filename: '', // 文件的名称
      text: '', // 语音转文字的文本结果
      status: 'stop', // 音频状态
      currentTime: 0, // 当前播放时间
      isDraggingProgress: false, // 是否在拖动音频进度条
      collapsesOpen: false, // 语音转文字部分是否展开
      containerHeight: textFontSize * textLineHeight * textLineCount,
      offsetHeight: 500
    };
  },
  computed: {
    // 当前播放时间转换为 00:00 格式
    formatTime() {
      return this.format(this.currentTime);
    },
    // 当前总时长转换为 00:00 格式
    formatDuration() {
      if (!this.duration || isNaN(this.duration) || !isFinite(this.duration)) {
        return '00:00';
      }
      return this.format(this.duration);
    },
    // 转换为 00:00 格式
    format() {
      return function(time) {
        const minutes = Math.floor(time / 60);
        const seconds = (time % 60).toFixed(0);
        return `${minutes > 9 ? minutes : `0${minutes}`}:${seconds > 9 ? seconds : `0${seconds}`}`;
      };
    },
    // 根据时长计算进度条位置比例时使用
    computedDuration() {
      if (!this.duration || isNaN(this.duration)) {
        return 1;
      }
      return this.duration;
    },
    // 语音转文字折叠状态容器样式
    collapsesStyle() {
      const maxHeight = textFontSize * textLineHeight * (textLineCount + 1);
      return this.collapsesOpen ? '' : `position: relative; max-height: ${maxHeight}px; overflow: hidden;`;
    },
    // 语音转文字折叠状态按钮样式
    collapsesBtnStyle() {
      const maxHeight = textFontSize * textLineHeight * 2;
      return this.collapsesOpen ? '' : `position: absolute; left: 0; top: ${maxHeight}px; background-color: #F4F4F4;`;
    }
  },
  mounted() {
    this.isIOS = /\b(iPad|iPhone|iPod)(?=;)/.test(window.navigator.userAgent);
    this.isApp = this.env === 'app';
    const _this = this;
    if (this.isApp) {
      window.onresize = () => {
        const resizeHeight = document.documentElement.scrollHeight;
        const height = resizeHeight - _this.originHeight;
        !this.isIOS && jsBridge.callCHandler({
          nativeMethod: 'onAudioCollapsesOpen',
          data: {
            collapsesOpen: height > 0 ? '1' : '0',
            collapsesHeight: Math.abs(height)
          }
        });
        _this.originHeight = resizeHeight;
      };
      this.isIOS && this.getContainerHeight();
    }
  },
  methods: {
    // 获取转换文字部分的真实高度
    getContainerHeight() {
      setTimeout(() => {
        this.offsetHeight = this.$refs.innerWrap ? this.$refs.innerWrap.clientHeight : 0;
        this._height = this.offsetHeight - this.containerHeight; // 内容的高度减去固定2行的高度
      }, 0);
    },
    // 阻止音频父容器默认点击事件执行
    mousedownHandler(e) {
      const tagName = e.target.tagName;
      if (tagName !== 'TEXTAREA' && tagName !== 'INPUT' && tagName !== 'AUDIO') {
        e.preventDefault();
      }
    },
    /**
     * 监听音频播放事件
     * */
    onPlay() {
      const audioAndVideoArr = Array.from(document.querySelectorAll('audio, video'));
      audioAndVideoArr.forEach((item) => {
        if (!item.paused && item !== this.$refs.audio) {
          item.pause();
        }
      });
      this.status = 'play';
    },
    // 监听音频暂停事件
    onPause() {
      this.status = 'stop';
    },
    // 监听音频停止事件
    onStop() {
      this.status = 'stop';
      this.currentTime = 0;
    },
    // 监听音频加载
    onLoading() {
      this.status = 'loading';
    },
    // 监听音频是否可播放
    onCanPlay() {
      this.status = this.$refs.audio.paused ? 'stop' : 'play';
    },
    // 监听音频进度变化
    onTimeUpdate(e) {
      if (!this.isDraggingProgress) {
        this.currentTime = Number(e.target.currentTime).toFixed(0);
      }
    },
    // 音频资源加载完成后更新duration
    onLoadedMeteData(e) {
      const duration = e.target.duration;
      if (duration && !isNaN(duration) && isFinite(duration)) {
        this.duration = Number(duration).toFixed(0);
      }
    },
    // 播放按钮点击
    handleClick() {
      const _this = this;
      if (_this.status === 'loading') {
        return;
      }
      if (this.status === 'play') {
        this.status = 'stop';
        this.$refs.audio.pause();
      } else if (this.status === 'stop') {
        this.status = 'play';
        this.$refs.audio.play().catch(e => {
          toast.inform(e.message || '音频播放出错啦');
        });
      }
    },
    // 开始拖动进度条
    onDragStart(e) {
      const seek = this.$refs.seek;
      const audio = this.$refs.audio;
      const { currentTime } = getCurrentProgress(e, seek, audio);
      if (isFinite(currentTime)) {
        timeOnMouseMove = currentTime;
        this.isDraggingProgress = true;
        this.currentTime = currentTime;
        if (e instanceof MouseEvent) {
          window.addEventListener('mousemove', this.handleWindowMouseOrTouchMove);
          window.addEventListener('mouseup', this.handleWindowMouseOrTouchUp);
        } else {
          window.addEventListener('touchmove', this.handleWindowMouseOrTouchMove);
          window.addEventListener('touchend', this.handleWindowMouseOrTouchUp);
          window.addEventListener('touchcancel', this.handleWindowMouseOrTouchUp);
        }
      }
    },
    // 拖动进度条
    handleWindowMouseOrTouchMove(e) {
      if (e instanceof MouseEvent) {
        e.preventDefault();
      }
      e.stopPropagation();
      // Prevent Chrome drag selection bug
      const windowSelection = window.getSelection();
      if (windowSelection && windowSelection.type === 'Range') {
        windowSelection.empty();
      }
      if (this.isDraggingProgress) {
        const seek = this.$refs.seek;
        const audio = this.$refs.audio;
        const { currentTime } = getCurrentProgress(e, seek, audio);
        timeOnMouseMove = currentTime;
        this.currentTime = currentTime;
      }
    },
    // 结束拖动进度条
    handleWindowMouseOrTouchUp(event) {
      event.stopPropagation();
      const audio = this.$refs.audio;
      audio.currentTime = timeOnMouseMove;
      this.isDraggingProgress = false;
      if (event instanceof MouseEvent) {
        window.removeEventListener('mousemove', this.handleWindowMouseOrTouchMove);
        window.removeEventListener('mouseup', this.handleWindowMouseOrTouchUp);
      } else {
        window.removeEventListener('touchmove', this.handleWindowMouseOrTouchMove);
        window.removeEventListener('touchend', this.handleWindowMouseOrTouchUp);
        window.removeEventListener('touchcancel', this.handleWindowMouseOrTouchUp);
      }
    },
    // // 文字转换部分展开收起
    handleToggle() {
      this.originHeight = document.documentElement.scrollHeight;
      const toggleCollapse = () => {
        this.collapsesOpen = !this.collapsesOpen;
        this.onAudioCollapse();
      };
      toggleCollapse();
      !this.collapsesOpen && !isPc() && document.getElementById(this.attachmentId).scrollIntoView({ // 只有触屏的收起触发
        behavior: 'smooth', // 平滑过渡
        block: 'start' // 上边框与视窗顶部平齐
      });
      // ios 走这个方法传递height android 通过window.resize 触发 因为部分安卓通过下面这个方法获取不准确
      this.isApp && this.isIOS && jsBridge.callCHandler({
        nativeMethod: 'onAudioCollapsesOpen',
        data: {
          collapsesOpen: this.collapsesOpen ? '1' : '0',
          collapsesHeight: this._height
        }
      });
    },
    // 医生圈调用此方法
    onAudioCollapse() {
      // 详情页通知ios，高度变化，重新绘制webview高度
      if (
        this.env === 'app'
      ) {
        this.$nextTick(() => {
          jsBridge.callCHandler({
            nativeMethod: 'onAudioCollapse',
            data: {
              changeHeight: this.collapsesOpen ? this._height : -(this._height)
            }
          });
        });
      }
    }
  }
};
</script>
<style lang="scss">
  @import "./index.scss";
</style>
